import {VALUES} from '../../constants/values'

export function GhostActor(): JSX.Element {
  return <span>{VALUES.ghost.login} </span>
}

try{ GhostActor.displayName ||= 'GhostActor' } catch {}